import React from 'react';
import { cn } from '../../../lib/utils';
import { InfoField, InfoFieldProps } from './InfoField';


export interface EditableInfoFieldProps {
  label: string;
  value: string | number;
  name: string;
  isEditing: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  orientation?: InfoFieldProps['orientation'];
  containerClassName?: string;
  valueClassName?: string;
  type?: string;
  placeholder?:string;
}


export const EditableInfoField = React.forwardRef<HTMLInputElement, EditableInfoFieldProps>(({
  label,
  value,
  name,
  isEditing,
  onChange,
  orientation = 'horizontal',
  containerClassName,
  valueClassName,
  type = 'text',
  placeholder,
}, ref) => {

  if (isEditing) {

    if (orientation === 'vertical') {
      return (
        <div className={cn("flex-1", containerClassName)}>
          {!!label &&
            <label htmlFor={name} className="block text-sm font-medium text-gray-600 mb-1">
              {label}
            </label>
          }
          <input
            ref={ref}
            id={name}
            name={name}
            type={type}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            className={cn(
              "w-full rounded-md border border-gray-300 px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm transition-colors focus:border-blue-500 focus:ring-blue-500",
              valueClassName
            )}
          />
        </div>
      );
    }

    return (
      <div className={cn("flex items-center justify-between", containerClassName)}>
        {!!label && 
          <label htmlFor={name} className="text-sm font-normal text-gray-600">
            {label}
          </label>
        }
        <input
          ref={ref}
          id={name}
          name={name}
          type={type}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          className={cn(
            "flex-grow ml-4 rounded-md border border-gray-300 px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm transition-colors focus:border-blue-500 focus:ring-blue-500",
            valueClassName
          )}
        />
      </div>
    );
  }

  return (
    <InfoField
      label={label}
      value={value}
      orientation={orientation}
      containerClassName={containerClassName}
      valueClassName={valueClassName}
    />
  );
});

EditableInfoField.displayName = 'EditableInfoField';